import Vue from 'vue';
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from "../erc20";

import $utils from "@/lib/utils/index.js";

const contractInfo = require('./NftMigrate.json')

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.nftMigrateContractAddress;
let contractConst = {
  contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getNftMigrateAddress = () => {
  return contractAddress;
}

const getNftMigrateContract = () => {
  return contractConst.contract;
}
// 得到某用户所有的token信息
// function getUserTotalNftInfos(address user) public view returns(NftInfo[] memory infos)
const getNftMigrateUserTotalNftInfos = ([user, handles, handlerParams], options) => {
  return $web3js.call(getNftMigrateContract().methods.getUserTotalNftInfos, [user], options, handlerUserTotalNftInfos, [handles, handlerParams]);
}

// struct NftInfo {
//   address     owner; //nft拥有者
//   Version     v; //版本
//   uint256     pid; //项目id
//   uint256     tokenId; //token Id
//   uint256     endTimestamp;//到期时间
//   uint256     amount;//本金数
//   bool        claimed;//是否已赎回
//   uint256     avail;//现在可赎回数量
 // string name;
// }
const handlerUserTotalNftInfos = async (res) => {
  console.log(res)
  let results = [];
  for (let i = 0; i < res.length; i++) {
    let info = res[i];
    let NftInfo = {};
    NftInfo.owner = info.owner
    NftInfo.v = info.v
    NftInfo.pid = info.pid
    NftInfo.tokenId = info.tokenId
    NftInfo.endTimestamp = info.endTimestamp
    NftInfo.amount = await $web3js.fromWei(info.amount)
    NftInfo.claimed = info.claimed
    NftInfo.avail = await $web3js.fromWei(info.avail);
    NftInfo.name = info.name
    results.push(NftInfo);
  }

  return results;
}

const nftMigrateClaimAll = ([], options, callback) => {
  return $web3js.send(getNftMigrateContract().methods.claimAll, [], options, callback);
}

const nftMigrateClaimAllEstimateSend = async ([], options) => {
  let gasPromise = $web3js.estimateSend(getNftMigrateContract().methods.claimAll, [], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return {gas, gasPrice, fee};
}

const nftMigrateClaimOne = ([_v, tokenId], options, callback) => {
  return $web3js.send(getNftMigrateContract().methods.claimOne, [_v, tokenId], options, callback);
}

const nftMigrateClaimOneEstimateSend = async ([_v, tokenId], options) => {
  let gasPromise = $web3js.estimateSend(getNftMigrateContract().methods.claimOne, [_v, tokenId], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return {gas, gasPrice, fee};
}


export default {
  getNftMigrateAddress,
  getNftMigrateContract,
  getNftMigrateUserTotalNftInfos,
  nftMigrateClaimAll,
  nftMigrateClaimAllEstimateSend,
  nftMigrateClaimOne,
  nftMigrateClaimOneEstimateSend
}



// WEBPACK FOOTER //
// ./src/lib/contract/nftMigrate/index.js